import { render, staticRenderFns } from "./internetTraffic.vue?vue&type=template&id=183b6117&scoped=true"
import script from "./internetTraffic.vue?vue&type=script&lang=js"
export * from "./internetTraffic.vue?vue&type=script&lang=js"
import style0 from "./internetTraffic.vue?vue&type=style&index=0&id=183b6117&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183b6117",
  null
  
)

export default component.exports